<template>
  <ul class="translation" @click="handleClick">
    <li :class="`translation__item ${translationPlayClass}`">
      <i class="material-icons md-24">play_arrow</i>
    </li>
    <li :class="`translation__item ${translationStopClass}`">
      <i class="material-icons md-24 color_red">stop</i>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Translation",
  data() {
    return {
      translationPlay: false
    };
  },
  computed: {
    translationPlayClass() {
      return !this.translationPlay ? "translation__item--current" : "";
    },
    translationStopClass() {
      return this.translationPlay ? "translation__item--current" : "";
    }
  },
  methods: {
    handleClick() {
      this.translationPlay = !this.translationPlay;
      this.$emit("onToggleTranslation");
    }
  },
};
</script>

<style>
.translation {
  padding: 0;
  margin: 0 33px 0 0;
  list-style: none;
  max-height: 24px;
}

.translation__item {
  display: none;
}

.translation__item--current {
  display: block;
  cursor: pointer;
}

@media (max-width: 1040px) {
  .translation {
    margin-right: 10px;
  }
}
</style>
